import {z} from 'zod';
import {TranslationFunction} from '../i18n/types';
import {Entity} from '../models/Entity';

export const JoinWaitlistRequestSchema = z.object({
  email: z.email(),
});
export type JoinWaitlistRequest = z.infer<typeof JoinWaitlistRequestSchema>;

export interface WaitlistEntry extends Entity {
  email: string;
}

export const createEmailSchema = (translate?: TranslationFunction) =>
  z.object({
    email: z.email({message: translate?.('auth:field.email.invalid')}),
  });

const MIN_PASSWORD_LENGTH = 8;
export const createCredentialsSchema = (translate?: TranslationFunction) =>
  createEmailSchema(translate).extend({
    password: z
      .string()
      .min(MIN_PASSWORD_LENGTH, translate?.('auth:field.password.invalid', {minPasswordLength: MIN_PASSWORD_LENGTH})),
  });

export type Credentials = z.infer<ReturnType<typeof createCredentialsSchema>>;

export const createSignupSchema = (translate?: TranslationFunction) =>
  createCredentialsSchema(translate).extend({
    name: z.string().min(1, translate?.('auth:field.name.invalid')),
  });

export const SignupSchema = createSignupSchema();
export type Signup = z.infer<typeof SignupSchema>;

/**
 * Details included in the error when a signup is blocked.
 * Used by the functions package to throw the error.
 */
export interface SignupBlockedDetails {
  email: string;
  waitlistEligible: boolean;
}
